import React from 'react'
import { Button, FormattedHTMLMessage } from '@web/walter-ui-kit'

import styles from './style.module.css'
import { lang } from './lang'

interface Props {
    onRefresh: () => void
}

function HistoryError({ onRefresh }: Props) {
    return (
        <div className={styles.wrap} data-pointer="empty_transaction_history_placeholder">
            <FormattedHTMLMessage {...lang.title} className={styles.title} tagName="div" />
            <FormattedHTMLMessage {...lang.text} className={styles.text} tagName="div" />
            <div className={styles.btn}>
                <Button dataPointer="refresh_button" mode="primary" role="button" onClick={onRefresh}>
                    <FormattedHTMLMessage {...lang.btn} />
                </Button>
            </div>
        </div>
    )
}

export default HistoryError
